import { noop } from "@silo/utils";
import { ProtocolInstanceList } from "./ProtocolInstanceMenu";
import { useSiloWeb3 } from "../../SiloWeb3Provider";
import { Modal } from "@silo/ui";
import { ReactNode } from "react";

interface NetworkGuardProps {
  children?: ReactNode;
}

export const NetworkGuard = ({ children }: NetworkGuardProps) => {
  const { isInvalidChain } = useSiloWeb3();

  return (
    <>
      <Modal isOpen={isInvalidChain} notDismissable closeModal={noop}>
        <div className="flex flex-col gap-6">
          <h2 className="text-xl font-bold text-white">Switch network</h2>

          <p>
            You are connected to an unsupported network. Please connect to{" "}
            <span className="font-bold">Ethereum</span> or another supported
            network.
          </p>

          {/* TODO: may need to switch to network menu if there are a large number of supported networks in the future */}
          <ProtocolInstanceList />
        </div>
      </Modal>
      {children}
    </>
  );
};
